/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.modals.discount.controllers', [
  'acme.common.service.api'
])

.controller('TemplatesModalsDiscountController', ['$scope', '$uibModalInstance', '$filter', 'ApiService', 'discountId', function($scope, $uibModalInstance, $filter, ApiService, discountId) {

    $scope.templatesModalsDiscount = {

      model: false,

      errors: [],

      discountTypes: [
        {
          label: 'Percent',
          type: 'PercentageBased'
        },
        {
          label: 'Value',
          type: 'AmountBased'
        }
      ],

      init: function() {
        this.getDiscount();
      },

      hasData: function() {
        return (this.model);
      },

      formatTicketTypeValue: function(discount) {
        var value = '',
          type = '';

        switch (discount.selectedDiscountType.type) {
          case 'PercentageBased':
            type = discount.selectedDiscountType.label;
            value = parseFloat(discount.displayValue);
            value.toPrecision(2);
            if (!value || value === 0 || isNaN(value)) {
              value = 0;
            }
            value = Math.abs(value);
            value += '%';
            break;
          case 'AmountBased':
            type = discount.selectedDiscountType.label;
          /* falls through */
          default:
            value = $filter('number')(discount.displayValue, 2);
            value = Math.abs(value) + '';
            if (!value || value === 0 || isNaN(value)) {
              value = "0.00";
            }
            break;
        }
        discount.discountType = type;
        discount.displayValue = value;
      },

      findDiscountType: function(type, returnObject) {
        var i, ii,
          r = false;
        console.log('PricingDiscountsController::findDiscountType', type);

        for (i=0,ii=this.discountTypes.length;i<ii;i++) {
          if (type === this.discountTypes[i].type) {
            r = i;
            if (returnObject) {
              r = this.discountTypes[i];
            }
            break;
          }
        }

        return r;
      },

      process: function(discount) {

        var i, ii;

        for (i=0,ii=discount.values.length;i<ii;i++) {
          discount.values[i].selectedDiscountType = this.findDiscountType(discount.values[i].discountType, true);
          discount.values[i].displayValue = discount.values[i].value;
          this.formatTicketTypeValue(discount.values[i]);
        }

        return discount;

      },


      getDiscount: function() {
        ApiService.discounts.detail(discountId).then(this.handlers.success.init, this.handlers.error.init);
      },

      handlers: {
        success: {
          init: function(response) {
            $scope.templatesModalsDiscount.model = $scope.templatesModalsDiscount.process(response.data.payload);
          }
        },
        error: {
          init: function (response) {
            $scope.templatesModalsDiscount.errors = [
              {
                message: response.data.error
              }
            ];
          }
        }
      },

      hasErrors: function() {
        return ($scope.templatesModalsDiscount.errors.length > 0);
      },

      done: function() {
        this.success();
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: function () {
        $uibModalInstance.close(true);
      }

    };

    $scope.templatesModalsDiscount.init();

}]);